<template>
  <div>
    <div ref="anomaliesOriginsChart"></div>
  </div>
</template>

<script>
import ReportService from "@/services/ReportService"
import ApexCharts from "apexcharts"
export default {
  name: "Overview",
  props: ["id", "filter"],
  data() {
    return {
      series: [],
      categories: [],
      chartOptions: {},
      chart: null
    }
  },
  created() {},
  watch: {
    filter(newValue) {
      this.getAnomaliesOrigins(true)
    }
  },
  mounted() {
    this.getAnomaliesOrigins()
  },
  methods: {
    getAnomaliesOrigins(updated) {
      this.$emit("anomaliesOriginsLoading", true)
      const $ = this
      this.categories = []
      this.series = []
      ReportService.getAnomaliesOrigins(this, this.id, this.filter)
        .then(r => {
          for (const [key, value] of Object.entries(r)) {
            $.categories.push(key)
            $.series.push(value)
          }
        })
        .finally(() => {
          this.chartOptions = {
            noData: { text: "No anomalies detected." },
            colors: ["#481c74", "#Ff444c", "#94c41c", "#00B0FF", "#FFC565", "#9F88B1", "#6F0400"],
            chart: {
              type: "radar",
              id: "anomaliesOriginsChart",
              height: "200%"
              // width: "100%"
            },
            plotOptions: {
              // radar: {
              //     size: '45'
              // }
            },
            legend: {
              position: "right",
              showForSingleSeries: true,
              formatter: function (val, opts) {
                let res = ""
                opts.w.globals.labels.map((r, i) => {
                  res += r + " : " + opts.w.globals.series[opts.seriesIndex][i] + "<br>\n"
                })
                return res
              },
              fontSize: "14px"
            },
            xaxis: {
              categories: []
            },
            series: [],
            markers: {
              size: 5,
              hover: {
                size: 10
              }
            }
          }
          this.chartOptions = {
            ...this.chartOptions,
            ...{
              series: [
                {
                  name: "Anomalies origins",
                  data: $.series
                }
              ],
              xaxis: {
                categories: $.categories
              }
            }
          }
          if (!updated) {
            this.chart = new ApexCharts($.$refs.anomaliesOriginsChart, this.chartOptions)
            this.chart.render()
          } else {
            $.chart.updateOptions($.chartOptions)
          }

          this.$emit("anomaliesOriginsLoading", false)
        })
    }
  }
}
</script>
